import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";
export const feeApi = createApi({
  reducerPath: "feeApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    GetSingleFee: builder.query({
      query: (id) => ({
        url: `/fee/${id}`,
        method: "GET",
      }),
      providesTags: ["Fee"],
    }),
    GetAllFee: builder.query({
      query: (Token) => ({
        url: `/fee`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["Fee"],
      invalidatesTags: ["Students", "Student"],
    }),
    SaveFee: builder.mutation({
      query: ({ id, Token, data }) => ({
        url: `/fee/${id}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      invalidatesTags: ["Fee"],
    }),
    UpdateFee: builder.mutation({
      query: ({ id, Token, data }) => ({
        url: `/fee/${id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      invalidatesTags: ["Fee"],
    }),
    DeleteFee: builder.mutation({
      query: ({ id, Token }) => ({
        url: `/fee/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      invalidatesTags: ["Fee"],
    }),
    GetAllFeeBYMonth: builder.query({
      query: (Token) => ({
        url: `/fee/all`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["Fee"],
      invalidatesTags: ["Students"],
    }),
  }),
});

export const {
  useGetAllFeeQuery,
  useGetSingleFeeQuery,
  useSaveFeeMutation,
  useDeleteFeeMutation,
  useUpdateFeeMutation,
  useGetAllFeeBYMonthQuery,
} = feeApi;
